module.exports = __webpack_public_path__ + "img/bg_2.5cf3c230.jpg";